import { MessageCircle, Copy } from "lucide-react";
import { useLongPress } from "../../hooks/useLongPress";
import { copyToClipboard } from "../../lib/leads";
import { toast } from "./Toast";

/* WhatsApp tap target: short tap → opens wa.me link in new tab;
   long press → copies the number. Visible copy button next to it
   for desktop discoverability. */
export function WhatsAppTap({ mobile, label, className = "" }) {
  const bind = useLongPress({
    onShortTap: () => window.open("https://wa.me/91" + mobile, "_blank", "noopener,noreferrer"),
    onLongPress: () => { copyToClipboard("+91" + mobile); toast("WhatsApp number copied"); },
  });
  const copy = (e) => {
    e.stopPropagation();
    e.preventDefault();
    copyToClipboard("+91" + mobile);
    toast("WhatsApp number copied");
  };
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap ${className}`} onClick={(e) => e.stopPropagation()}>
      <span
        role="button"
        tabIndex={0}
        {...bind}
        // See PhoneTap — same reason.
        className="inline-flex items-center gap-1.5 tabular-nums select-none whitespace-nowrap cursor-pointer text-green-700 hover:text-green-900"
        title="Tap to message · long-press to copy"
      >
        <MessageCircle className="w-3.5 h-3.5" />{label || mobile}
      </span>
      <button
        type="button"
        onClick={copy}
        title="Copy number"
        aria-label="Copy WhatsApp number"
        className="text-slate-400 hover:text-green-700 transition-colors p-0.5"
      >
        <Copy className="w-3.5 h-3.5" />
      </button>
    </span>
  );
}
